import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox } from '@bingads-webui-react/checkbox';

export const CallToActionOptOut = (props) => {
  const {
    i18n,
    data,
    onDataChange,
  } = props;

  const isCallToActionOptOut = data.campaign.IsCallToActionOptOut;

  const onCheckedChange = (event) => {
    const { checked } = event.target;
    onDataChange({
      data: {
        ...data,
        campaign: {
          ...data.campaign,
          IsCallToActionOptOut: !checked,
        },
      },
      isValid: true,
    });
  };

  return (
    <div style={{ marginLeft: 3 }}>
      <Checkbox
        className={`${!isCallToActionOptOut ? 'checked' : ''} call-to-action-enable-checkbox`}
        checked={!isCallToActionOptOut}
        onChange={onCheckedChange}
      >
        {i18n.getString(_TL_('Enable calls to action for Native ads'))}
      </Checkbox>
    </div>
  );
};

CallToActionOptOut.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
